import { motion } from "framer-motion";
import { Clock, Repeat, Trash2, Zap, Heart, TrendingUp, CalendarCheck, Layout } from "lucide-react";
import { SectionHeader } from "@/components/sections/SectionHeader";

const BENEFITS = [
  { icon: Clock, title: "Reduci timpul de pregătire" },
  { icon: Repeat, title: "Ai produse constante" },
  { icon: Trash2, title: "Reduci pierderile" },
  { icon: Zap, title: "Servești rapid" },
  { icon: Heart, title: "Păstrezi gustul bun" },
  { icon: TrendingUp, title: "Crești marja de profit" },
  { icon: CalendarCheck, title: "Lucrezi predictibil" },
  { icon: Layout, title: "Vitrină, meniu, livrare" },
];

export default function HorecaBenefits() {
  return (
    <section data-testid="horeca-benefits" className="section-pad bg-bg">
      <div className="max-w-7xl mx-auto container-px">
        <SectionHeader
          eyebrow="Avantaje pentru HoReCa"
          title="Mai puțin timp pierdut. Mai multă constanță. Mai mult profit."
          subtitle="Un produs bun trebuie să fie și gustos, și eficient. DOTAPAN ajută locațiile să reducă timpul de lucru, să controleze costurile și să ofere produse care arată bine de fiecare dată."
          testId="benefits-header"
        />
        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {BENEFITS.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="card-soft p-6 flex flex-col gap-4 items-start"
              data-testid={`benefit-${i}`}
            >
              <div className="h-10 w-10 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center">
                <b.icon className="h-5 w-5 text-gold" />
              </div>
              <h3 className="font-display text-base md:text-lg text-text leading-snug">{b.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
